/**
 * <ImageBlock> — basic inline image render (v1). Lightbox/zoom is a
 * followup.
 */
import type { ImageBlock as ImageBlockType } from "@/types/content-blocks";

interface ImageBlockProps {
  block: ImageBlockType;
}

export function ImageBlock({ block }: ImageBlockProps) {
  if (!block.mediaUrl) {
    // No URL — render a placeholder badge (mediaId-only case, server
    // didn't materialize a fetchable URL). Followup: resolve mediaId via
    // a separate RPC before render.
    return (
      <div
        data-testid="image-block-placeholder"
        className="my-1 inline-flex items-center rounded border border-cream-300 bg-cream-100/30 px-2 py-1 text-caption text-coffee-500 dark:border-coffee-700 dark:bg-coffee-900/30"
      >
        Image attached{block.mediaType ? ` (${block.mediaType})` : ""}
      </div>
    );
  }
  return (
    <img
      data-testid="image-block"
      src={block.mediaUrl}
      alt={block.alt ?? ""}
      className="my-2 max-w-full rounded-md border border-cream-300 dark:border-coffee-700"
    />
  );
}
